import { render, staticRenderFns } from "./ClientSettings.vue?vue&type=template&id=00b04ed6&scoped=true&"
import script from "./ClientSettings.vue?vue&type=script&lang=js&"
export * from "./ClientSettings.vue?vue&type=script&lang=js&"
import style0 from "./ClientSettings.vue?vue&type=style&index=0&id=00b04ed6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b04ed6",
  null
  
)

export default component.exports